import React from 'react';
import AreaCityIcon from '../../../../Icons/AreaCity';
import LocationIcon from '../../../../Icons/Location';
import HotelIcon from '../../../../Icons/Hotel';
import {isDefined, nonNullable} from '../../../../../types/type-guards';
import styled, {ThemeProps} from 'styled-components';

// import {Theme} from '@stencil/build-theme/src/types';

interface VoyagerHotelSearch {
  n: string; // location name
  t: string; // type of location
  _id: number; // id,
  xtr: {
    g_rtg?: number;
    gri?: number;
  };
}

export const itemToString = (item: VoyagerHotelSearch) => {
  return item.n;
};

// 🐨 give it full item properties and types
type Item = {t: string};
export const isHotel = (item: Item) => item.t === 'hotel';
export const isLocation = (item: Item) => item.t === 'landmark' || item.t === 'area';

// 🐨 give a generic when autosuggest hook's types are done

export const getSegregatedItems = items => {
  const defaultSegregatedItems = {
    hotelItems: [],
    locationItems: [],
  };

  if (!nonNullable(items)) {
    return defaultSegregatedItems;
  }

  const segregationFunction = (segregatedMap, unsegregatedItem) => {
    if (isHotel(unsegregatedItem)) {
      return {
        ...segregatedMap,
        hotelItems: [...segregatedMap.hotelItems, unsegregatedItem],
      };
    }

    if (isLocation(unsegregatedItem)) {
      return {
        ...segregatedMap,
        locationItems: [...segregatedMap.locationItems, unsegregatedItem],
      };
    }

    return defaultSegregatedItems;
  };

  return items.reduce(segregationFunction, defaultSegregatedItems);
};

/** DO NOT DELETE THIS. THIS IS TS CODE WHICH NEEDS TO BE UNCOMMENTED WHEN OTHER TYPES ARE RIGHT */
// type SegregatedItemsType = {
//   hotelItems: Item[],
//   locationItems: Item[]
// }

// export const getSegregatedItems = (items: Item[] | undefined) => {

//   const defaultSegregatedItems: SegregatedItemsType = {
//     hotelItems: [],
//     locationItems: [],
//   }

//   if (!nonNullable(items)) {
//     return defaultSegregatedItems
//   }

//   type SegregationFunctionType = (
//     segregatedMap: SegregatedItemsType,
//     unsegregatedItem: Item
//   ) => SegregatedItemsType

//   const segregationFunction: SegregationFunctionType = (
//     segregatedMap,
//     unsegregatedItem
//   ) => {
//     if (isHotel(unsegregatedItem)) {
//       return {
//         ...segregatedMap,
//         hotelItems: [
//           ...segregatedMap.hotelItems,
//           unsegregatedItem
//         ]
//       }
//     }

//     if (isLocation(unsegregatedItem)) {
//       return {
//         ...segregatedMap,
//         locationItems: [
//           ...segregatedMap.locationItems, unsegregatedItem
//         ]
//       }
//     }

//     return defaultSegregatedItems
//   }

//   return items.reduce(
//     segregationFunction,
//     defaultSegregatedItems
//   );
// }
